export default __webpack_public_path__ + "static/media/fever.4489f7de.svg";